import React from 'react'

import Base from '../_Base'

const CsChevronUp = (props) => (
  <Base width="15" height="8" viewBox="0 0 15 8" stroke="black" {...props}>
    <path
      d="M1 7l6.5-6L14 7"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Base>
)

export default CsChevronUp
